export const CHART_COLORS = {
  primary: "#3660f9",
  success: "#14A44D",
  warning: "#ff9800",
  error: "#ff0500",
  info: "#0288d1",
  teal: "#19857b",
  purple: "#7c3aed",
  pink: "#ec4899",
  slate: "#64748b",
  amber: "#f59e0b",
};

export const CHART_PALETTE = [
  CHART_COLORS.primary,
  CHART_COLORS.success,
  CHART_COLORS.warning,
  CHART_COLORS.error,
  CHART_COLORS.info,
  CHART_COLORS.teal,
  CHART_COLORS.purple,
  CHART_COLORS.pink,
  CHART_COLORS.slate,
  CHART_COLORS.amber,
];

export const PAYMENT_STATUS_COLORS: Record<string, string> = {
  paid: CHART_COLORS.success,
  pending_confirmation: CHART_COLORS.warning,
  unpaid: CHART_COLORS.slate,
  failed: CHART_COLORS.error,
  refused: "#b91c1c",
  rejected: "#991b1b",
  cancelled: CHART_COLORS.slate,
  refunded: CHART_COLORS.info,
  partial_refund: CHART_COLORS.purple,
  chargeback: CHART_COLORS.pink,
};

export const DELIVERY_STATUS_COLORS: Record<string, string> = {
  delivered: CHART_COLORS.success,
  pending: CHART_COLORS.warning,
  in_progress: CHART_COLORS.info,
  failed: CHART_COLORS.error,
  delivery_failed: "#b91c1c",
  cancelled: CHART_COLORS.slate,
  refunded: CHART_COLORS.purple,
  returned: CHART_COLORS.pink,
  rejected: "#991b1b",
  partially_delivered: CHART_COLORS.amber,
};

export const REFUND_STATUS_COLORS: Record<string, string> = {
  refund_requested: CHART_COLORS.warning,
  refund_processing: CHART_COLORS.info,
  refund_declined: CHART_COLORS.error,
  refunded: CHART_COLORS.success,
  failed: "#b91c1c",
  credit_memo: CHART_COLORS.purple,
};

export const PIN_STATUS_COLORS: Record<string, string> = {
  unassigned: CHART_COLORS.info,
  assigned: CHART_COLORS.success,
  blocked: CHART_COLORS.error,
  reserved: CHART_COLORS.warning,
};

export const DATE_PRESETS = [
  { label: "Today", days: 0 },
  { label: "7D", days: 7 },
  { label: "30D", days: 30 },
  { label: "90D", days: 90 },
];

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat("en-US").format(value);
};

export const formatPercent = (value: number): string => {
  return `${value.toFixed(1)}%`;
};

export const formatStatusLabel = (status: string): string => {
  return status
    .replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());
};
